/** One keyboard-accessible photo viewer used by both editors. */
export function createListingPhotoLightbox(modal, getItems) {
    let index = 0, trigger, previousOverflow;
    const image = modal.querySelector('[data-plf-photo-lightbox-image]');
    const counter = modal.querySelector('[data-plf-photo-lightbox-counter]');
    const previous = modal.querySelector('[data-plf-photo-lightbox-previous]');
    const next = modal.querySelector('[data-plf-photo-lightbox-next]');
    const closeButton = modal.querySelector('section [data-plf-photo-lightbox-close]');
    const items = () => getItems().filter(item => item.url);
    function close() {
        if (modal.hidden) return;
        modal.hidden = true;
        document.documentElement.style.overflow = previousOverflow;
        image.removeAttribute('src');
        if (trigger?.isConnected) trigger.focus();
    }
    function render() {
        const photos = items();
        if (!photos.length) { close(); return; }
        index = Math.min(Math.max(0, index), photos.length - 1);
        image.src = photos[index].url;
        image.alt = `Zdjęcie ${index + 1}`;
        counter.textContent = `Zdjęcie ${index + 1} z ${photos.length}`;
        previous.disabled = index === 0;
        next.disabled = index === photos.length - 1;
    }
    modal.querySelectorAll('[data-plf-photo-lightbox-close]').forEach(button => button.addEventListener('click', close));
    previous.addEventListener('click', () => { index--; render(); });
    next.addEventListener('click', () => { index++; render(); });
    modal.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key === 'ArrowLeft' && !previous.disabled) previous.click();
        if (event.key === 'ArrowRight' && !next.disabled) next.click();
        if (event.key === 'Tab') {
            const controls = [...modal.querySelectorAll('section button:not(:disabled)')];
            const position = controls.indexOf(document.activeElement);
            event.preventDefault();
            controls[(position + (event.shiftKey ? controls.length - 1 : 1)) % controls.length]?.focus();
        }
    });
    return {
        close,
        open(key, source) {
            index = items().findIndex(item => item.key === key);
            if (index < 0) return;
            trigger = source;
            previousOverflow = document.documentElement.style.overflow;
            modal.hidden = false;
            render();
            document.documentElement.style.overflow = 'hidden';
            closeButton.focus();
        },
    };
}
